<template>
  <div class="login-password">
    <div class="page-title" style="cursor: pointer" @click="goBack">
      <i class="el-icon-arrow-left"></i> {{ $t("message.home.LoginPassword") }}
    </div>
    <el-form ref="form" class="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('message.home.oldPassword')" prop="currentPassword">
        <el-input v-model="formData.currentPassword" :type="showPassword.oldPassword ? 'text' : 'password'"
          :placeholder="$t('message.home.pleaseEnterOldPassword')">
          <template #suffix>
            <div class="eye-icon" @click="showPassword.oldPassword = !showPassword.oldPassword">
              <img :src="showPassword.oldPassword ? eyeIcon.open : eyeIcon.close" alt="" />
            </div>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('message.home.newPassword')" prop="password">
        <el-input v-model="formData.password" :type="showPassword.newPassword ? 'text' : 'password'"
          :placeholder="$t('message.home.plaseeEnterNewPassword')">
          <template #suffix>
            <div class="eye-icon" @click="showPassword.newPassword = !showPassword.newPassword">
              <img :src="showPassword.newPassword ? eyeIcon.open : eyeIcon.close" alt="" />
            </div>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('message.home.confirmPassword')" prop="confirmPassword">
        <el-input v-model="formData.confirmPassword" :type="showPassword.confirmPassword ? 'text' : 'password'"
          :placeholder="$t('message.home.plaseeENterConfirmPassword')">
          <template #suffix>
            <div class="eye-icon" @click="
              showPassword.confirmPassword = !showPassword.confirmPassword
              ">
              <img :src="showPassword.confirmPassword ? eyeIcon.open : eyeIcon.close
                " alt="" />
            </div>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="form-submit-btn" type="submit" :loading="loading" block @click="update_password">
          {{ $t("message.home.btnSure") }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import common from "@/util/common";
//////////////////////////////////////////////////////////////////////////////////////////////////

import {
  check_current_password,
  edit,
  update
} from "@/api/upms/password.js"

//////////////////////////////////////////////////////////////////////////////////////////////////
export default {
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      showPassword: {
        oldPassword: false,
        newPassword: false,
        confirmPassword: false,
      },
      eyeIcon: {
        close: require("@/assets/image/eye-close.png"),
        open: require("@/assets/image/eye-open.png"),
      },
      rules: {
        currentPassword: [
          common.ruleUtils.getRule(
            "required",
            this.$t("message.home.pleaseEnterOldPassword")
          ),
          common.ruleUtils.getRule("password"),
        ],
        password: [
          common.ruleUtils.getRule(
            "required",
            this.$t("message.home.plaseeEnterNewPassword")
          ),
          common.ruleUtils.getRule("password"),
        ],
        confirmPassword: [
          common.ruleUtils.getRule(
            "required",
            this.$t("message.home.plaseeENterConfirmPassword")
          ),
          common.ruleUtils.getRule("validator", "", {
            validator: (rule, value, callback) => {
              if (value !== this.formData.password) {
                callback(new Error(this.$t("message.home.twoPawword")));
                return;
              }
              callback();
            },
          }),
        ],
      },
      loading: false,

      //////////////////////////////////////////////////////////////////////////////////////////////////

      objsList: [],
      userInfo: {},
      orderInfo: {},
      loadingHidden: false,
      formData: {
        currentPassword: "",
        password: "",
        confirmPassword: ""
      },

      //////////////////////////////////////////////////////////////////////////////////////////////////
    };
  },
  methods: {
    ...mapActions({ logout: "logout" }),
    ...mapActions("user", ["requestUpdateLoginPasswordList"]),
    update() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            await this.requestUpdateLoginPasswordList({
              old_password: encodeURIComponent(this.formData.currentPassword),
              password: encodeURIComponent(this.formData.password),
              re_password: encodeURIComponent(this.formData.confirmPassword),
            });
            this.$message({
              message: this.$t("message.home.successTips"),
              type: "success",
            });
            this.$router.replace("/userInfo/dashboard?index=1");
          } finally {
            this.loading = false;
          }
        }
      });
    },
    goBack() {
      this.$router.push("/userInfo/setup");
    },
    //////////////////////////////////////////////////////////////////////////////////////////////////



    update_password() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formData.confirmPassword != this.formData.password) {
            this.$message({
              message: this.$t("message.home.twoPawword"),
              type: "error",
            });
            return;
          }
          this.loading = true;
          check_current_password(this.formData).then(response => {
            if (response.data) {
              update(this.formData).then(response => {
                this.loading=false;
                this.$message({
                  message: this.$t("message.home.successTips"),
                  type: "success",
                });
                this.logout();
                /**
                 * 退出登录，路由都定向到首页，防止在详情页面还能进行购物等操作
                 */
                if (this.$router.currentRoute.path !== "/index") {
                  this.$router.replace("/index");
                }
              });
            } else {
              this.loading=false;
              this.$message({
                message: this.$t("message.home.旧密码不正确"),
                type: "error",
              });
            }
          });
        }
      });
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////
  },
};
</script>

<style lang="scss" scoped>
html[dir="rtl"] {
  .el-form-item v::deep .el-form-item__error {
    right: 0;
    left: auto;
  }

  .el-form-item v::deep .el-form-item__label {
    float: right;
  }
}

.login-password {
  width: 422px;

  .eye-icon {
    width: 30px;
    height: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    >img {
      width: 14px;
      margin: 0;
    }
  }
}
</style>
